<script setup>
import {computed, ref} from "vue";

    const emit = defineEmits(['close', 'select-icon', 'select-weight']);

    const props = defineProps({
        open: {
            type: Boolean,
            default: false
        }
    })

    const icons = [
        {name: "link", class: "fa-link", faName: "link"},
        {name: "search", class: "fa-search", faName: "search"},
        {name: "image", class: "fa-image", faName: "image"},
        {name: "header", class: "fa-header", faName: "header"},
        {name: "forward", class: "fa-forward", faName: "forward"},
        {name: "retweet", class: "fa-retweet", faName: "retweet"},
        {name: "minus", class: "fa-minus", faName: "minus"},
        {name: "plus", class: "fa-plus", faName: "plus"},
        {name: "info", class: "fa-info", faName: "info"},
        {name: "exclamation", class: "fa-exclamation", faName: "exclamation"},
        {name: "check", class: "fa-check", faName: "check"},
        {name: "close", class: "fa-close", faName: "close"},
        {name: "book", class: "fa-book", faName: "book"},
        {name: "bars", class: "fa-bars", faName: "bars"},
        {name: "question", class: "fa-question", faName: "question"},
        {name: "pause", class: "fa-pause", faName: "pause"},
        {name: "home", class: "fa-home", faName: "home"},
        {name: "laptop", class: "fa-laptop", faName: "laptop"},
        {name: "star", class: "fa-star", faName: "star"},
        {name: "filter", class: "fa-filter", faName: "filter"},
        {name: "save", class: "fa-save", faName: "save"},
        {name: "user", class: "fa-user", faName: "user"},
        {name: "phone", class: "fa-phone", faName: "phone"},
        {name: "paperclip", class: "fa-paperclip", faName: "paperclip"},
        {name: "inbox", class: "fa-inbox", faName: "inbox"},
        {name: "lock", class: "fa-lock", faName: "lock"},
        {name: "qrcode", class: "fa-qrcode", faName: "qrcode"},
        {name: "tags", class: "fa-tags", faName: "tags"},
        {name: "cloud", class: "fa-cloud", faName: "cloud"},
        {name: "eye", class: "fa-eye", faName: "eye"},
        {name: "camera", class: "fa-camera", faName: "camera"},
        {name: "windows", class: "fa-windows", faName: "windows"},
        {name: "heart", class: "fa-heart", faName: "heart"},
        {name: "calculator", class: "fa-calculator", faName: "calculator"},
        {name: "chrome", class: "fa-chrome", faName: "chrome"},
        {name: "github", class: "fa-github", faName: "github"},
        {name: "upload", class: "fa-upload", faName: "upload"},
        {name: "download", class: "fa-download", faName: "download"},
        {name: "unlock", class: "fa-unlock", faName: "unlock"},
        {name: "play", class: "fa-play", faName: "play"},
        {name: "tag", class: "fa-tag", faName: "tag"},
        {name: "calendar", class: "fa-calendar", faName: "calendar"},
        {name: "database", class: "fa-database", faName: "database"},
        {name: "barcode", class: "fa-barcode", faName: "barcode"},
        {name: "hourglass", class: "fa-hourglass", faName: "hourglass"},
        {name: "key", class: "fa-key", faName: "key"},
        {name: "flag", class: "fa-flag", faName: "flag"},
        {name: "car", class: "fa-car", faName: "car"},
        {name: "gift", class: "fa-gift", faName: "gift"},
        {name: "bank", class: "fa-bank", faName: "bank"},
        {name: "android", class: "fa-android", faName: "android"},
        {name: "trademark", class: "fa-trademark", faName: "trademark"},
        {name: "copyright", class: "fa-copyright", faName: "copyright"},
        {name: "wifi", class: "fa-wifi", faName: "wifi"},
        {name: "edit", class: "fa-edit", faName: "edit"},
        {name: "warning", class: "fa-warning", faName: "warning"},
        {name: "table", class: "fa-table", faName: "table"},
        {name: "dashboard", class: "fa-dashboard", faName: "dashboard"},
        {name: "google", class: "fa-google", faName: "google"},
        {name: "amazon", class: "fa-amazon", faName: "amazon"},
        {name: "codepen", class: "fa-codepen", faName: "codepen"},
        {name: "facebook-square", class: "fa-facebook-square", faName: "facebook-square"},
        {name: "dropbox", class: "fa-dropbox", faName: "dropbox"},
        {name: "linkedin-square", class: "fa-linkedin-square", faName: "linkedin-square"},
        {name: "gitlab", class: "fa-gitlab", faName: "gitlab"},
        {name: "skype", class: "fa-skype", faName: "skype"},
        {name: "youtube", class: "fa-youtube", faName: "youtube"},
        {name: "wechat", class: "fa-wechat", faName: "wechat"},
        {name: "twitter", class: "fa-twitter", faName: "twitter"},
        {name: "weibo", class: "fa-weibo", faName: "weibo"},
        {name: "behance", class: "fa-behance", faName: "behance"},
        {name: "dribbble", class: "fa-dribbble", faName: "dribbble"},
        {name: "behance-square", class: "fa-behance-square", faName: "behance-square"},
        {name: "instagram", class: "fa-instagram", faName: "instagram"},
        {name: "slack", class: "fa-slack", faName: "slack"},
        {name: "500px", class: "fa-500px", faName: "500px"},
        {name: "adjust", class: "fa-adjust", faName: "adjust"},
        {name: "align-left", class: "fa-align-left", faName: "align-left"},
        {name: "align-right", class: "fa-align-right", faName: "align-right"},
        {name: "archive", class: "fa-archive", faName: "archive"},
        {name: "arrow-down", class: "fa-arrow-down", faName: "arrow-down"},
        {name: "arrow-left", class: "fa-arrow-left", faName: "arrow-left"},
        {name: "arrow-right", class: "fa-arrow-right", faName: "arrow-right"},
        {name: "arrow-up", class: "fa-arrow-up", faName: "arrow-up"},
        {name: "battery", class: "fa-battery", faName: "battery"},
        {name: "bell", class: "fa-bell", faName: "bell"},
        {name: "bookmark", class: "fa-bookmark", faName: "bookmark"},
        {name: "briefcase", class: "fa-briefcase", faName: "briefcase"},
        {name: "bug", class: "fa-bug", faName: "bug"},
        {name: "chevron-down", class: "fa-chevron-down", faName: "chevron-down"},
        {name: "chevron-left", class: "fa-chevron-left", faName: "chevron-left"},
        {name: "chevron-right", class: "fa-chevron-right", faName: "chevron-right"},
        {name: "chevron-up", class: "fa-chevron-up", faName: "chevron-up"},
        {name: "circle", class: "fa-circle", faName: "circle"},
        {name: "clipboard", class: "fa-clipboard", faName: "clipboard"},
        {name: "code", class: "fa-code", faName: "code"},
        {name: "cog", class: "fa-cog", faName: "cog"},
        {name: "compass", class: "fa-compass", faName: "compass"},
        {name: "copy", class: "fa-copy", faName: "copy"},
        {name: "creative-commons", class: "fa-creative-commons", faName: "creative-commons"},
        {name: "credit-card", class: "fa-credit-card", faName: "credit-card"},
        {name: "crop", class: "fa-crop", faName: "crop"},
        {name: "eraser", class: "fa-eraser", faName: "eraser"},
        {name: "facebook", class: "fa-facebook", faName: "facebook"},
        {name: "flash", class: "fa-flash", faName: "flash"},
        {name: "flickr", class: "fa-flickr", faName: "flickr"},
        {name: "folder", class: "fa-folder", faName: "folder"},
        {name: "foursquare", class: "fa-foursquare", faName: "foursquare"},
        {name: "globe", class: "fa-globe", faName: "globe"},
        {name: "graduation-cap", class: "fa-graduation-cap", faName: "graduation-cap"},
        {name: "houzz", class: "fa-houzz", faName: "houzz"},
        {name: "language", class: "fa-language", faName: "language"},
        {name: "lastfm", class: "fa-lastfm", faName: "lastfm"},
        {name: "leaf", class: "fa-leaf", faName: "leaf"},
        {name: "level-down", class: "fa-level-down", faName: "level-down"},
        {name: "level-up", class: "fa-level-up", faName: "level-up"},
        {name: "linkedin", class: "fa-linkedin", faName: "linkedin"},
        {name: "list", class: "fa-list", faName: "list"},
        {name: "magnet", class: "fa-magnet", faName: "magnet"},
        {name: "map", class: "fa-map", faName: "map"},
        {name: "medium", class: "fa-medium", faName: "medium"},
        {name: "mobile", class: "fa-mobile", faName: "mobile"},
        {name: "mouse-pointer", class: "fa-mouse-pointer", faName: "mouse-pointer"},
        {name: "music", class: "fa-music", faName: "music"},
        {name: "paper-plane", class: "fa-paper-plane", faName: "paper-plane"},
        {name: "paypal", class: "fa-paypal", faName: "paypal"},
        {name: "pencil", class: "fa-pencil", faName: "pencil"},
        {name: "pie-chart", class: "fa-pie-chart", faName: "pie-chart"},
        {name: "pinterest", class: "fa-pinterest", faName: "pinterest"},
        {name: "print", class: "fa-print", faName: "print"},
        {name: "qq", class: "fa-qq", faName: "qq"},
        {name: "renren", class: "fa-renren", faName: "renren"},
        {name: "reply", class: "fa-reply", faName: "reply"},
        {name: "reply-all", class: "fa-reply-all", faName: "reply-all"},
        {name: "rocket", class: "fa-rocket", faName: "rocket"},
        {name: "rss", class: "fa-rss", faName: "rss"},
        {name: "scissors", class: "fa-scissors", faName: "scissors"},
        {name: "scribd", class: "fa-scribd", faName: "scribd"},
        {name: "share", class: "fa-share", faName: "share"},
        {name: "shield", class: "fa-shield", faName: "shield"},
        {name: "shopping-bag", class: "fa-shopping-bag", faName: "shopping-bag"},
        {name: "shopping-basket", class: "fa-shopping-basket", faName: "shopping-basket"},
        {name: "shopping-cart", class: "fa-shopping-cart", faName: "shopping-cart"},
        {name: "signal", class: "fa-signal", faName: "signal"},
        {name: "slideshare", class: "fa-slideshare", faName: "slideshare"},
        {name: "soundcloud", class: "fa-soundcloud", faName: "soundcloud"},
        {name: "spotify", class: "fa-spotify", faName: "spotify"},
        {name: "stumbleupon", class: "fa-stumbleupon", faName: "stumbleupon"},
        {name: "suitcase", class: "fa-suitcase", faName: "suitcase"},
        {name: "tablet", class: "fa-tablet", faName: "tablet"},
        {name: "thermometer", class: "fa-thermometer", faName: "thermometer"},
        {name: "thumbs-down", class: "fa-thumbs-down", faName: "thumbs-down"},
        {name: "thumbs-up", class: "fa-thumbs-up", faName: "thumbs-up"},
        {name: "ticket", class: "fa-ticket", faName: "ticket"},
        {name: "trash", class: "fa-trash", faName: "trash"},
        {name: "tree", class: "fa-tree", faName: "tree"},
        {name: "tripadvisor", class: "fa-tripadvisor", faName: "tripadvisor"},
        {name: "trophy", class: "fa-trophy", faName: "trophy"},
        {name: "tumblr", class: "fa-tumblr", faName: "tumblr"},
        {name: "tv", class: "fa-tv", faName: "tv"},
        {name: "users", class: "fa-users", faName: "users"},
        {name: "video-camera", class: "fa-video-camera", faName: "video-camera"},
        {name: "vimeo", class: "fa-vimeo", faName: "vimeo"},
        {name: "vine", class: "fa-vine", faName: "vine"},
        {name: "vk", class: "fa-vk", faName: "vk"},
        {name: "xing", class: "fa-xing", faName: "xing"},
        {name: "yelp", class: "fa-yelp", faName: "yelp"},
        {name: "comment", class: "fa-comment", faName: "comment"},
        {name: "envelope", class: "fa-envelope", faName: "envelope"},
        {name: "external-link", class: "fa-external-link", faName: "external-link"},
        {name: "gear", class: "fa-gear", faName: "gear"},
        {name: "navicon", class: "fa-navicon", faName: "navicon"},
        {name: "refresh", class: "fa-refresh", faName: "refresh"},
        {name: "spinner", class: "fa-spinner", faName: "spinner"},
        {name: "undo", class: "fa-undo", faName: "undo"},
        {name: "align-center", class: "fa-align-center", faName: "align-center"},
        {name: "align-justify", class: "fa-align-justify", faName: "align-justify"},
        {name: "anchor", class: "fa-anchor", faName: "anchor"},
        {name: "bar-chart", class: "fa-bar-chart", faName: "bar-chart"},
        {name: "bluetooth", class: "fa-bluetooth", faName: "bluetooth"},
        {name: "bold", class: "fa-bold", faName: "bold"},
        {name: "check-circle", class: "fa-check-circle", faName: "check-circle"},
        {name: "check-square", class: "fa-check-square", faName: "check-square"},
        {name: "coffee", class: "fa-coffee", faName: "coffee"},
        {name: "columns", class: "fa-columns", faName: "columns"},
        {name: "fast-forward", class: "fa-fast-forward", faName: "fast-forward"},
        {name: "file", class: "fa-file", faName: "file"},
        {name: "file-text", class: "fa-file-text", faName: "file-text"},
        {name: "film", class: "fa-film", faName: "film"},
        {name: "headphones", class: "fa-headphones", faName: "headphones"},
        {name: "italic", class: "fa-italic", faName: "italic"},
        {name: "life-buoy", class: "fa-life-buoy", faName: "life-buoy"},
        {name: "map-pin", class: "fa-map-pin", faName: "map-pin"},
        {name: "minus-circle", class: "fa-minus-circle", faName: "minus-circle"},
        {name: "minus-square", class: "fa-minus-square", faName: "minus-square"},
        {name: "pause-circle", class: "fa-pause-circle", faName: "pause-circle"},
        {name: "percent", class: "fa-percent", faName: "percent"},
        {name: "play-circle", class: "fa-play-circle", faName: "play-circle"},
        {name: "plus-circle", class: "fa-plus-circle", faName: "plus-circle"},
        {name: "plus-square", class: "fa-plus-square", faName: "plus-square"},
        {name: "repeat", class: "fa-repeat", faName: "repeat"},
        {name: "send", class: "fa-send", faName: "send"},
        {name: "server", class: "fa-server", faName: "server"},
        {name: "sliders", class: "fa-sliders", faName: "sliders"},
        {name: "square", class: "fa-square", faName: "square"},
        {name: "stop-circle", class: "fa-stop-circle", faName: "stop-circle"},
        {name: "terminal", class: "fa-terminal", faName: "terminal"},
        {name: "toggle-left", class: "fa-toggle-left", faName: "toggle-left"},
        {name: "toggle-right", class: "fa-toggle-right", faName: "toggle-right"},
        {name: "trello", class: "fa-trello", faName: "trello"},
        {name: "truck", class: "fa-truck", faName: "truck"},
        {name: "twitch", class: "fa-twitch", faName: "twitch"},
        {name: "umbrella", class: "fa-umbrella", faName: "umbrella"},
        {name: "underline", class: "fa-underline", faName: "underline"},
        {name: "user-plus", class: "fa-user-plus", faName: "user-plus"},
        {name: "glass", class: "fa-glass", faName: "glass"},
        {name: "envelope-o", class: "fa-envelope-o", faName: "envelope-o"},
        {name: "star-o", class: "fa-star-o", faName: "star-o"},
        {name: "th-large", class: "fa-th-large", faName: "th-large"},
        {name: "th", class: "fa-th", faName: "th"},
        {name: "th-list", class: "fa-th-list", faName: "th-list"},
        {name: "remove", class: "fa-remove", faName: "remove"},
        {name: "times", class: "fa-times", faName: "times"},
        {name: "search-plus", class: "fa-search-plus", faName: "search-plus"},
        {name: "search-minus", class: "fa-search-minus", faName: "search-minus"},
        {name: "power-off", class: "fa-power-off", faName: "power-off"},
        {name: "trash-o", class: "fa-trash-o", faName: "trash-o"},
        {name: "file-o", class: "fa-file-o", faName: "file-o"},
        {name: "clock-o", class: "fa-clock-o", faName: "clock-o"},
        {name: "road", class: "fa-road", faName: "road"},
        {name: "arrow-circle-o-down", class: "fa-arrow-circle-o-down", faName: "arrow-circle-o-down"},
        {name: "arrow-circle-o-up", class: "fa-arrow-circle-o-up", faName: "arrow-circle-o-up"},
        {name: "play-circle-o", class: "fa-play-circle-o", faName: "play-circle-o"},
        {name: "rotate-right", class: "fa-rotate-right", faName: "rotate-right"},
        {name: "list-alt", class: "fa-list-alt", faName: "list-alt"},
        {name: "volume-off", class: "fa-volume-off", faName: "volume-off"},
        {name: "volume-down", class: "fa-volume-down", faName: "volume-down"},
        {name: "volume-up", class: "fa-volume-up", faName: "volume-up"},
        {name: "font", class: "fa-font", faName: "font"},
        {name: "text-height", class: "fa-text-height", faName: "text-height"},
        {name: "text-width", class: "fa-text-width", faName: "text-width"},
        {name: "dedent", class: "fa-dedent", faName: "dedent"},
        {name: "outdent", class: "fa-outdent", faName: "outdent"},
        {name: "indent", class: "fa-indent", faName: "indent"},
        {name: "photo", class: "fa-photo", faName: "photo"},
        {name: "picture-o", class: "fa-picture-o", faName: "picture-o"},
        {name: "map-marker", class: "fa-map-marker", faName: "map-marker"},
        {name: "tint", class: "fa-tint", faName: "tint"},
        {name: "pencil-square-o", class: "fa-pencil-square-o", faName: "pencil-square-o"},
        {name: "share-square-o", class: "fa-share-square-o", faName: "share-square-o"},
        {name: "check-square-o", class: "fa-check-square-o", faName: "check-square-o"},
        {name: "arrows", class: "fa-arrows", faName: "arrows"},
        {name: "step-backward", class: "fa-step-backward", faName: "step-backward"},
        {name: "fast-backward", class: "fa-fast-backward", faName: "fast-backward"},
        {name: "backward", class: "fa-backward", faName: "backward"},
        {name: "stop", class: "fa-stop", faName: "stop"},
        {name: "step-forward", class: "fa-step-forward", faName: "step-forward"},
        {name: "eject", class: "fa-eject", faName: "eject"},
        {name: "times-circle", class: "fa-times-circle", faName: "times-circle"},
        {name: "question-circle", class: "fa-question-circle", faName: "question-circle"},
        {name: "info-circle", class: "fa-info-circle", faName: "info-circle"},
        {name: "crosshairs", class: "fa-crosshairs", faName: "crosshairs"},
        {name: "times-circle-o", class: "fa-times-circle-o", faName: "times-circle-o"},
        {name: "check-circle-o", class: "fa-check-circle-o", faName: "check-circle-o"},
        {name: "ban", class: "fa-ban", faName: "ban"},
        {name: "mail-forward", class: "fa-mail-forward", faName: "mail-forward"},
        {name: "expand", class: "fa-expand", faName: "expand"},
        {name: "compress", class: "fa-compress", faName: "compress"},
        {name: "asterisk", class: "fa-asterisk", faName: "asterisk"},
        {name: "exclamation-circle", class: "fa-exclamation-circle", faName: "exclamation-circle"},
        {name: "fire", class: "fa-fire", faName: "fire"},
        {name: "eye-slash", class: "fa-eye-slash", faName: "eye-slash"},
        {name: "exclamation-triangle", class: "fa-exclamation-triangle", faName: "exclamation-triangle"},
        {name: "plane", class: "fa-plane", faName: "plane"},
        {name: "random", class: "fa-random", faName: "random"},
        {name: "folder-open", class: "fa-folder-open", faName: "folder-open"},
        {name: "arrows-v", class: "fa-arrows-v", faName: "arrows-v"},
        {name: "arrows-h", class: "fa-arrows-h", faName: "arrows-h"},
        {name: "bar-chart-o", class: "fa-bar-chart-o", faName: "bar-chart-o"},
        {name: "twitter-square", class: "fa-twitter-square", faName: "twitter-square"},
        {name: "camera-retro", class: "fa-camera-retro", faName: "camera-retro"},
        {name: "gears", class: "fa-gears", faName: "gears"},
        {name: "cogs", class: "fa-cogs", faName: "cogs"},
        {name: "comments", class: "fa-comments", faName: "comments"},
        {name: "thumbs-o-up", class: "fa-thumbs-o-up", faName: "thumbs-o-up"},
        {name: "thumbs-o-down", class: "fa-thumbs-o-down", faName: "thumbs-o-down"},
        {name: "star-half", class: "fa-star-half", faName: "star-half"},
        {name: "heart-o", class: "fa-heart-o", faName: "heart-o"},
        {name: "sign-out", class: "fa-sign-out", faName: "sign-out"},
        {name: "thumb-tack", class: "fa-thumb-tack", faName: "thumb-tack"},
        {name: "sign-in", class: "fa-sign-in", faName: "sign-in"},
        {name: "github-square", class: "fa-github-square", faName: "github-square"},
        {name: "lemon-o", class: "fa-lemon-o", faName: "lemon-o"},
        {name: "square-o", class: "fa-square-o", faName: "square-o"},
        {name: "bookmark-o", class: "fa-bookmark-o", faName: "bookmark-o"},
        {name: "phone-square", class: "fa-phone-square", faName: "phone-square"},
        {name: "facebook-f", class: "fa-facebook-f", faName: "facebook-f"},
        {name: "feed", class: "fa-feed", faName: "feed"},
        {name: "hdd-o", class: "fa-hdd-o", faName: "hdd-o"},
        {name: "bullhorn", class: "fa-bullhorn", faName: "bullhorn"},
        {name: "certificate", class: "fa-certificate", faName: "certificate"},
        {name: "hand-o-right", class: "fa-hand-o-right", faName: "hand-o-right"},
        {name: "hand-o-left", class: "fa-hand-o-left", faName: "hand-o-left"},
        {name: "hand-o-up", class: "fa-hand-o-up", faName: "hand-o-up"},
        {name: "hand-o-down", class: "fa-hand-o-down", faName: "hand-o-down"},
        {name: "arrow-circle-left", class: "fa-arrow-circle-left", faName: "arrow-circle-left"},
        {name: "arrow-circle-right", class: "fa-arrow-circle-right", faName: "arrow-circle-right"},
        {name: "arrow-circle-up", class: "fa-arrow-circle-up", faName: "arrow-circle-up"},
        {name: "arrow-circle-down", class: "fa-arrow-circle-down", faName: "arrow-circle-down"},
        {name: "wrench", class: "fa-wrench", faName: "wrench"},
        {name: "tasks", class: "fa-tasks", faName: "tasks"},
        {name: "arrows-alt", class: "fa-arrows-alt", faName: "arrows-alt"},
        {name: "group", class: "fa-group", faName: "group"},
        {name: "chain", class: "fa-chain", faName: "chain"},
        {name: "flask", class: "fa-flask", faName: "flask"},
        {name: "cut", class: "fa-cut", faName: "cut"},
        {name: "files-o", class: "fa-files-o", faName: "files-o"},
        {name: "floppy-o", class: "fa-floppy-o", faName: "floppy-o"},
        {name: "reorder", class: "fa-reorder", faName: "reorder"},
        {name: "list-ul", class: "fa-list-ul", faName: "list-ul"},
        {name: "list-ol", class: "fa-list-ol", faName: "list-ol"},
        {name: "strikethrough", class: "fa-strikethrough", faName: "strikethrough"},
        {name: "magic", class: "fa-magic", faName: "magic"},
        {name: "pinterest-square", class: "fa-pinterest-square", faName: "pinterest-square"},
        {name: "google-plus-square", class: "fa-google-plus-square", faName: "google-plus-square"},
        {name: "google-plus", class: "fa-google-plus", faName: "google-plus"},
        {name: "money", class: "fa-money", faName: "money"},
        {name: "caret-down", class: "fa-caret-down", faName: "caret-down"},
        {name: "caret-up", class: "fa-caret-up", faName: "caret-up"},
        {name: "caret-left", class: "fa-caret-left", faName: "caret-left"},
        {name: "caret-right", class: "fa-caret-right", faName: "caret-right"},
        {name: "unsorted", class: "fa-unsorted", faName: "unsorted"},
        {name: "sort", class: "fa-sort", faName: "sort"},
        {name: "sort-down", class: "fa-sort-down", faName: "sort-down"},
        {name: "sort-desc", class: "fa-sort-desc", faName: "sort-desc"},
        {name: "sort-up", class: "fa-sort-up", faName: "sort-up"},
        {name: "sort-asc", class: "fa-sort-asc", faName: "sort-asc"},
        {name: "rotate-left", class: "fa-rotate-left", faName: "rotate-left"},
        {name: "legal", class: "fa-legal", faName: "legal"},
        {name: "gavel", class: "fa-gavel", faName: "gavel"},
        {name: "tachometer", class: "fa-tachometer", faName: "tachometer"},
        {name: "comment-o", class: "fa-comment-o", faName: "comment-o"},
        {name: "comments-o", class: "fa-comments-o", faName: "comments-o"},
        {name: "bolt", class: "fa-bolt", faName: "bolt"},
        {name: "sitemap", class: "fa-sitemap", faName: "sitemap"},
        {name: "paste", class: "fa-paste", faName: "paste"},
        {name: "lightbulb-o", class: "fa-lightbulb-o", faName: "lightbulb-o"},
        {name: "exchange", class: "fa-exchange", faName: "exchange"},
        {name: "cloud-download", class: "fa-cloud-download", faName: "cloud-download"},
        {name: "cloud-upload", class: "fa-cloud-upload", faName: "cloud-upload"},
        {name: "user-md", class: "fa-user-md", faName: "user-md"},
        {name: "stethoscope", class: "fa-stethoscope", faName: "stethoscope"},
        {name: "bell-o", class: "fa-bell-o", faName: "bell-o"},
        {name: "cutlery", class: "fa-cutlery", faName: "cutlery"},
        {name: "file-text-o", class: "fa-file-text-o", faName: "file-text-o"},
        {name: "building-o", class: "fa-building-o", faName: "building-o"},
        {name: "hospital-o", class: "fa-hospital-o", faName: "hospital-o"},
        {name: "ambulance", class: "fa-ambulance", faName: "ambulance"},
        {name: "medkit", class: "fa-medkit", faName: "medkit"},
        {name: "fighter-jet", class: "fa-fighter-jet", faName: "fighter-jet"},
        {name: "beer", class: "fa-beer", faName: "beer"},
        {name: "h-square", class: "fa-h-square", faName: "h-square"},
        {name: "angle-double-left", class: "fa-angle-double-left", faName: "angle-double-left"},
        {name: "angle-double-right", class: "fa-angle-double-right", faName: "angle-double-right"},
        {name: "angle-double-up", class: "fa-angle-double-up", faName: "angle-double-up"},
        {name: "angle-double-down", class: "fa-angle-double-down", faName: "angle-double-down"},
        {name: "angle-left", class: "fa-angle-left", faName: "angle-left"},
        {name: "angle-right", class: "fa-angle-right", faName: "angle-right"},
        {name: "angle-up", class: "fa-angle-up", faName: "angle-up"},
        {name: "angle-down", class: "fa-angle-down", faName: "angle-down"},
        {name: "desktop", class: "fa-desktop", faName: "desktop"},
        {name: "mobile-phone", class: "fa-mobile-phone", faName: "mobile-phone"},
        {name: "circle-o", class: "fa-circle-o", faName: "circle-o"},
        {name: "quote-left", class: "fa-quote-left", faName: "quote-left"},
        {name: "quote-right", class: "fa-quote-right", faName: "quote-right"},
        {name: "mail-reply", class: "fa-mail-reply", faName: "mail-reply"},
        {name: "github-alt", class: "fa-github-alt", faName: "github-alt"},
        {name: "folder-o", class: "fa-folder-o", faName: "folder-o"},
        {name: "folder-open-o", class: "fa-folder-open-o", faName: "folder-open-o"},
        {name: "smile-o", class: "fa-smile-o", faName: "smile-o"},
        {name: "frown-o", class: "fa-frown-o", faName: "frown-o"},
        {name: "meh-o", class: "fa-meh-o", faName: "meh-o"},
        {name: "gamepad", class: "fa-gamepad", faName: "gamepad"},
        {name: "keyboard-o", class: "fa-keyboard-o", faName: "keyboard-o"},
        {name: "flag-o", class: "fa-flag-o", faName: "flag-o"},
        {name: "flag-checkered", class: "fa-flag-checkered", faName: "flag-checkered"},
        {name: "mail-reply-all", class: "fa-mail-reply-all", faName: "mail-reply-all"},
        {name: "star-half-empty", class: "fa-star-half-empty", faName: "star-half-empty"},
        {name: "star-half-full", class: "fa-star-half-full", faName: "star-half-full"},
        {name: "star-half-o", class: "fa-star-half-o", faName: "star-half-o"},
        {name: "location-arrow", class: "fa-location-arrow", faName: "location-arrow"},
        {name: "code-fork", class: "fa-code-fork", faName: "code-fork"},
        {name: "unlink", class: "fa-unlink", faName: "unlink"},
        {name: "chain-broken", class: "fa-chain-broken", faName: "chain-broken"},
        {name: "superscript", class: "fa-superscript", faName: "superscript"},
        {name: "subscript", class: "fa-subscript", faName: "subscript"},
        {name: "puzzle-piece", class: "fa-puzzle-piece", faName: "puzzle-piece"},
        {name: "microphone", class: "fa-microphone", faName: "microphone"},
        {name: "microphone-slash", class: "fa-microphone-slash", faName: "microphone-slash"},
        {name: "calendar-o", class: "fa-calendar-o", faName: "calendar-o"},
        {name: "fire-extinguisher", class: "fa-fire-extinguisher", faName: "fire-extinguisher"},
        {name: "maxcdn", class: "fa-maxcdn", faName: "maxcdn"},
        {name: "chevron-circle-left", class: "fa-chevron-circle-left", faName: "chevron-circle-left"},
        {name: "chevron-circle-right", class: "fa-chevron-circle-right", faName: "chevron-circle-right"},
        {name: "chevron-circle-up", class: "fa-chevron-circle-up", faName: "chevron-circle-up"},
        {name: "chevron-circle-down", class: "fa-chevron-circle-down", faName: "chevron-circle-down"},
        {name: "html5", class: "fa-html5", faName: "html5"},
        {name: "css3", class: "fa-css3", faName: "css3"},
        {name: "unlock-alt", class: "fa-unlock-alt", faName: "unlock-alt"},
        {name: "bullseye", class: "fa-bullseye", faName: "bullseye"},
        {name: "ellipsis-h", class: "fa-ellipsis-h", faName: "ellipsis-h"},
        {name: "ellipsis-v", class: "fa-ellipsis-v", faName: "ellipsis-v"},
        {name: "rss-square", class: "fa-rss-square", faName: "rss-square"},
        {name: "minus-square-o", class: "fa-minus-square-o", faName: "minus-square-o"},
        {name: "pencil-square", class: "fa-pencil-square", faName: "pencil-square"},
        {name: "external-link-square", class: "fa-external-link-square", faName: "external-link-square"},
        {name: "share-square", class: "fa-share-square", faName: "share-square"},
        {name: "toggle-down", class: "fa-toggle-down", faName: "toggle-down"},
        {name: "caret-square-o-down", class: "fa-caret-square-o-down", faName: "caret-square-o-down"},
        {name: "toggle-up", class: "fa-toggle-up", faName: "toggle-up"},
        {name: "caret-square-o-up", class: "fa-caret-square-o-up", faName: "caret-square-o-up"},
        {name: "caret-square-o-right", class: "fa-caret-square-o-right", faName: "caret-square-o-right"},
        {name: "euro", class: "fa-euro", faName: "euro"},
        {name: "eur", class: "fa-eur", faName: "eur"},
        {name: "gbp", class: "fa-gbp", faName: "gbp"},
        {name: "dollar", class: "fa-dollar", faName: "dollar"},
        {name: "usd", class: "fa-usd", faName: "usd"},
        {name: "rupee", class: "fa-rupee", faName: "rupee"},
        {name: "inr", class: "fa-inr", faName: "inr"},
        {name: "cny", class: "fa-cny", faName: "cny"},
        {name: "rmb", class: "fa-rmb", faName: "rmb"},
        {name: "yen", class: "fa-yen", faName: "yen"},
        {name: "jpy", class: "fa-jpy", faName: "jpy"},
        {name: "ruble", class: "fa-ruble", faName: "ruble"},
        {name: "rouble", class: "fa-rouble", faName: "rouble"},
        {name: "rub", class: "fa-rub", faName: "rub"},
        {name: "won", class: "fa-won", faName: "won"},
        {name: "krw", class: "fa-krw", faName: "krw"},
        {name: "bitcoin", class: "fa-bitcoin", faName: "bitcoin"},
        {name: "btc", class: "fa-btc", faName: "btc"},
        {name: "sort-alpha-asc", class: "fa-sort-alpha-asc", faName: "sort-alpha-asc"},
        {name: "sort-alpha-desc", class: "fa-sort-alpha-desc", faName: "sort-alpha-desc"},
        {name: "sort-amount-asc", class: "fa-sort-amount-asc", faName: "sort-amount-asc"},
        {name: "sort-amount-desc", class: "fa-sort-amount-desc", faName: "sort-amount-desc"},
        {name: "sort-numeric-asc", class: "fa-sort-numeric-asc", faName: "sort-numeric-asc"},
        {name: "sort-numeric-desc", class: "fa-sort-numeric-desc", faName: "sort-numeric-desc"},
        {name: "youtube-square", class: "fa-youtube-square", faName: "youtube-square"},
        {name: "xing-square", class: "fa-xing-square", faName: "xing-square"},
        {name: "youtube-play", class: "fa-youtube-play", faName: "youtube-play"},
        {name: "stack-overflow", class: "fa-stack-overflow", faName: "stack-overflow"},
        {name: "adn", class: "fa-adn", faName: "adn"},
        {name: "bitbucket", class: "fa-bitbucket", faName: "bitbucket"},
        {name: "bitbucket-square", class: "fa-bitbucket-square", faName: "bitbucket-square"},
        {name: "tumblr-square", class: "fa-tumblr-square", faName: "tumblr-square"},
        {name: "long-arrow-down", class: "fa-long-arrow-down", faName: "long-arrow-down"},
        {name: "long-arrow-up", class: "fa-long-arrow-up", faName: "long-arrow-up"},
        {name: "long-arrow-left", class: "fa-long-arrow-left", faName: "long-arrow-left"},
        {name: "long-arrow-right", class: "fa-long-arrow-right", faName: "long-arrow-right"},
        {name: "apple", class: "fa-apple", faName: "apple"},
        {name: "linux", class: "fa-linux", faName: "linux"},
        {name: "female", class: "fa-female", faName: "female"},
        {name: "male", class: "fa-male", faName: "male"},
        {name: "gittip", class: "fa-gittip", faName: "gittip"},
        {name: "gratipay", class: "fa-gratipay", faName: "gratipay"},
        {name: "sun-o", class: "fa-sun-o", faName: "sun-o"},
        {name: "moon-o", class: "fa-moon-o", faName: "moon-o"},
        {name: "pagelines", class: "fa-pagelines", faName: "pagelines"},
        {name: "stack-exchange", class: "fa-stack-exchange", faName: "stack-exchange"},
        {name: "arrow-circle-o-right", class: "fa-arrow-circle-o-right", faName: "arrow-circle-o-right"},
        {name: "arrow-circle-o-left", class: "fa-arrow-circle-o-left", faName: "arrow-circle-o-left"},
        {name: "caret-square-o-left", class: "fa-caret-square-o-left", faName: "caret-square-o-left"},
        {name: "dot-circle-o", class: "fa-dot-circle-o", faName: "dot-circle-o"},
        {name: "wheelchair", class: "fa-wheelchair", faName: "wheelchair"},
        {name: "vimeo-square", class: "fa-vimeo-square", faName: "vimeo-square"},
        {name: "turkish-lira", class: "fa-turkish-lira", faName: "turkish-lira"},
        {name: "try", class: "fa-try", faName: "try"},
        {name: "plus-square-o", class: "fa-plus-square-o", faName: "plus-square-o"},
        {name: "space-shuttle", class: "fa-space-shuttle", faName: "space-shuttle"},
        {name: "envelope-square", class: "fa-envelope-square", faName: "envelope-square"},
        {name: "wordpress", class: "fa-wordpress", faName: "wordpress"},
        {name: "openid", class: "fa-openid", faName: "openid"},
        {name: "institution", class: "fa-institution", faName: "institution"},
        {name: "university", class: "fa-university", faName: "university"},
        {name: "mortar-board", class: "fa-mortar-board", faName: "mortar-board"},
        {name: "yahoo", class: "fa-yahoo", faName: "yahoo"},
        {name: "reddit", class: "fa-reddit", faName: "reddit"},
        {name: "reddit-square", class: "fa-reddit-square", faName: "reddit-square"},
        {name: "stumbleupon-circle", class: "fa-stumbleupon-circle", faName: "stumbleupon-circle"},
        {name: "delicious", class: "fa-delicious", faName: "delicious"},
        {name: "digg", class: "fa-digg", faName: "digg"},
        {name: "pied-piper-pp", class: "fa-pied-piper-pp", faName: "pied-piper-pp"},
        {name: "pied-piper-alt", class: "fa-pied-piper-alt", faName: "pied-piper-alt"},
        {name: "drupal", class: "fa-drupal", faName: "drupal"},
        {name: "joomla", class: "fa-joomla", faName: "joomla"},
        {name: "fax", class: "fa-fax", faName: "fax"},
        {name: "building", class: "fa-building", faName: "building"},
        {name: "child", class: "fa-child", faName: "child"},
        {name: "paw", class: "fa-paw", faName: "paw"},
        {name: "spoon", class: "fa-spoon", faName: "spoon"},
        {name: "cube", class: "fa-cube", faName: "cube"},
        {name: "cubes", class: "fa-cubes", faName: "cubes"},
        {name: "steam", class: "fa-steam", faName: "steam"},
        {name: "steam-square", class: "fa-steam-square", faName: "steam-square"},
        {name: "recycle", class: "fa-recycle", faName: "recycle"},
        {name: "automobile", class: "fa-automobile", faName: "automobile"},
        {name: "cab", class: "fa-cab", faName: "cab"},
        {name: "taxi", class: "fa-taxi", faName: "taxi"},
        {name: "deviantart", class: "fa-deviantart", faName: "deviantart"},
        {name: "file-pdf-o", class: "fa-file-pdf-o", faName: "file-pdf-o"},
        {name: "file-word-o", class: "fa-file-word-o", faName: "file-word-o"},
        {name: "file-excel-o", class: "fa-file-excel-o", faName: "file-excel-o"},
        {name: "file-powerpoint-o", class: "fa-file-powerpoint-o", faName: "file-powerpoint-o"},
        {name: "file-photo-o", class: "fa-file-photo-o", faName: "file-photo-o"},
        {name: "file-picture-o", class: "fa-file-picture-o", faName: "file-picture-o"},
        {name: "file-image-o", class: "fa-file-image-o", faName: "file-image-o"},
        {name: "file-zip-o", class: "fa-file-zip-o", faName: "file-zip-o"},
        {name: "file-archive-o", class: "fa-file-archive-o", faName: "file-archive-o"},
        {name: "file-sound-o", class: "fa-file-sound-o", faName: "file-sound-o"},
        {name: "file-audio-o", class: "fa-file-audio-o", faName: "file-audio-o"},
        {name: "file-movie-o", class: "fa-file-movie-o", faName: "file-movie-o"},
        {name: "file-video-o", class: "fa-file-video-o", faName: "file-video-o"},
        {name: "file-code-o", class: "fa-file-code-o", faName: "file-code-o"},
        {name: "jsfiddle", class: "fa-jsfiddle", faName: "jsfiddle"},
        {name: "life-bouy", class: "fa-life-bouy", faName: "life-bouy"},
        {name: "life-saver", class: "fa-life-saver", faName: "life-saver"},
        {name: "support", class: "fa-support", faName: "support"},
        {name: "life-ring", class: "fa-life-ring", faName: "life-ring"},
        {name: "circle-o-notch", class: "fa-circle-o-notch", faName: "circle-o-notch"},
        {name: "ra", class: "fa-ra", faName: "ra"},
        {name: "resistance", class: "fa-resistance", faName: "resistance"},
        {name: "rebel", class: "fa-rebel", faName: "rebel"},
        {name: "ge", class: "fa-ge", faName: "ge"},
        {name: "empire", class: "fa-empire", faName: "empire"},
        {name: "git-square", class: "fa-git-square", faName: "git-square"},
        {name: "git", class: "fa-git", faName: "git"},
        {name: "y-combinator-square", class: "fa-y-combinator-square", faName: "y-combinator-square"},
        {name: "yc-square", class: "fa-yc-square", faName: "yc-square"},
        {name: "hacker-news", class: "fa-hacker-news", faName: "hacker-news"},
        {name: "tencent-weibo", class: "fa-tencent-weibo", faName: "tencent-weibo"},
        {name: "weixin", class: "fa-weixin", faName: "weixin"},
        {name: "send-o", class: "fa-send-o", faName: "send-o"},
        {name: "paper-plane-o", class: "fa-paper-plane-o", faName: "paper-plane-o"},
        {name: "history", class: "fa-history", faName: "history"},
        {name: "circle-thin", class: "fa-circle-thin", faName: "circle-thin"},
        {name: "paragraph", class: "fa-paragraph", faName: "paragraph"},
        {name: "share-alt", class: "fa-share-alt", faName: "share-alt"},
        {name: "share-alt-square", class: "fa-share-alt-square", faName: "share-alt-square"},
        {name: "bomb", class: "fa-bomb", faName: "bomb"},
        {name: "soccer-ball-o", class: "fa-soccer-ball-o", faName: "soccer-ball-o"},
        {name: "futbol-o", class: "fa-futbol-o", faName: "futbol-o"},
        {name: "tty", class: "fa-tty", faName: "tty"},
        {name: "binoculars", class: "fa-binoculars", faName: "binoculars"},
        {name: "plug", class: "fa-plug", faName: "plug"},
        {name: "newspaper-o", class: "fa-newspaper-o", faName: "newspaper-o"},
        {name: "google-wallet", class: "fa-google-wallet", faName: "google-wallet"},
        {name: "cc-visa", class: "fa-cc-visa", faName: "cc-visa"},
        {name: "cc-mastercard", class: "fa-cc-mastercard", faName: "cc-mastercard"},
        {name: "cc-discover", class: "fa-cc-discover", faName: "cc-discover"},
        {name: "cc-amex", class: "fa-cc-amex", faName: "cc-amex"},
        {name: "cc-paypal", class: "fa-cc-paypal", faName: "cc-paypal"},
        {name: "cc-stripe", class: "fa-cc-stripe", faName: "cc-stripe"},
        {name: "bell-slash", class: "fa-bell-slash", faName: "bell-slash"},
        {name: "bell-slash-o", class: "fa-bell-slash-o", faName: "bell-slash-o"},
        {name: "at", class: "fa-at", faName: "at"},
        {name: "eyedropper", class: "fa-eyedropper", faName: "eyedropper"},
        {name: "paint-brush", class: "fa-paint-brush", faName: "paint-brush"},
        {name: "birthday-cake", class: "fa-birthday-cake", faName: "birthday-cake"},
        {name: "area-chart", class: "fa-area-chart", faName: "area-chart"},
        {name: "line-chart", class: "fa-line-chart", faName: "line-chart"},
        {name: "lastfm-square", class: "fa-lastfm-square", faName: "lastfm-square"},
        {name: "toggle-off", class: "fa-toggle-off", faName: "toggle-off"},
        {name: "toggle-on", class: "fa-toggle-on", faName: "toggle-on"},
        {name: "bicycle", class: "fa-bicycle", faName: "bicycle"},
        {name: "bus", class: "fa-bus", faName: "bus"},
        {name: "ioxhost", class: "fa-ioxhost", faName: "ioxhost"},
        {name: "angellist", class: "fa-angellist", faName: "angellist"},
        {name: "cc", class: "fa-cc", faName: "cc"},
        {name: "shekel", class: "fa-shekel", faName: "shekel"},
        {name: "sheqel", class: "fa-sheqel", faName: "sheqel"},
        {name: "ils", class: "fa-ils", faName: "ils"},
        {name: "meanpath", class: "fa-meanpath", faName: "meanpath"},
        {name: "buysellads", class: "fa-buysellads", faName: "buysellads"},
        {name: "connectdevelop", class: "fa-connectdevelop", faName: "connectdevelop"},
        {name: "dashcube", class: "fa-dashcube", faName: "dashcube"},
        {name: "forumbee", class: "fa-forumbee", faName: "forumbee"},
        {name: "leanpub", class: "fa-leanpub", faName: "leanpub"},
        {name: "sellsy", class: "fa-sellsy", faName: "sellsy"},
        {name: "shirtsinbulk", class: "fa-shirtsinbulk", faName: "shirtsinbulk"},
        {name: "simplybuilt", class: "fa-simplybuilt", faName: "simplybuilt"},
        {name: "skyatlas", class: "fa-skyatlas", faName: "skyatlas"},
        {name: "cart-plus", class: "fa-cart-plus", faName: "cart-plus"},
        {name: "cart-arrow-down", class: "fa-cart-arrow-down", faName: "cart-arrow-down"},
        {name: "diamond", class: "fa-diamond", faName: "diamond"},
        {name: "ship", class: "fa-ship", faName: "ship"},
        {name: "user-secret", class: "fa-user-secret", faName: "user-secret"},
        {name: "motorcycle", class: "fa-motorcycle", faName: "motorcycle"},
        {name: "street-view", class: "fa-street-view", faName: "street-view"},
        {name: "heartbeat", class: "fa-heartbeat", faName: "heartbeat"},
        {name: "venus", class: "fa-venus", faName: "venus"},
        {name: "mars", class: "fa-mars", faName: "mars"},
        {name: "mercury", class: "fa-mercury", faName: "mercury"},
        {name: "intersex", class: "fa-intersex", faName: "intersex"},
        {name: "transgender", class: "fa-transgender", faName: "transgender"},
        {name: "transgender-alt", class: "fa-transgender-alt", faName: "transgender-alt"},
        {name: "venus-double", class: "fa-venus-double", faName: "venus-double"},
        {name: "mars-double", class: "fa-mars-double", faName: "mars-double"},
        {name: "venus-mars", class: "fa-venus-mars", faName: "venus-mars"},
        {name: "mars-stroke", class: "fa-mars-stroke", faName: "mars-stroke"},
        {name: "mars-stroke-v", class: "fa-mars-stroke-v", faName: "mars-stroke-v"},
        {name: "mars-stroke-h", class: "fa-mars-stroke-h", faName: "mars-stroke-h"},
        {name: "neuter", class: "fa-neuter", faName: "neuter"},
        {name: "genderless", class: "fa-genderless", faName: "genderless"},
        {name: "facebook-official", class: "fa-facebook-official", faName: "facebook-official"},
        {name: "pinterest-p", class: "fa-pinterest-p", faName: "pinterest-p"},
        {name: "whatsapp", class: "fa-whatsapp", faName: "whatsapp"},
        {name: "user-times", class: "fa-user-times", faName: "user-times"},
        {name: "hotel", class: "fa-hotel", faName: "hotel"},
        {name: "bed", class: "fa-bed", faName: "bed"},
        {name: "viacoin", class: "fa-viacoin", faName: "viacoin"},
        {name: "train", class: "fa-train", faName: "train"},
        {name: "subway", class: "fa-subway", faName: "subway"},
        {name: "yc", class: "fa-yc", faName: "yc"},
        {name: "y-combinator", class: "fa-y-combinator", faName: "y-combinator"},
        {name: "optin-monster", class: "fa-optin-monster", faName: "optin-monster"},
        {name: "opencart", class: "fa-opencart", faName: "opencart"},
        {name: "expeditedssl", class: "fa-expeditedssl", faName: "expeditedssl"},
        {name: "battery-4", class: "fa-battery-4", faName: "battery-4"},
        {name: "battery-full", class: "fa-battery-full", faName: "battery-full"},
        {name: "battery-3", class: "fa-battery-3", faName: "battery-3"},
        {name: "battery-three-quarters", class: "fa-battery-three-quarters", faName: "battery-three-quarters"},
        {name: "battery-2", class: "fa-battery-2", faName: "battery-2"},
        {name: "battery-half", class: "fa-battery-half", faName: "battery-half"},
        {name: "battery-1", class: "fa-battery-1", faName: "battery-1"},
        {name: "battery-quarter", class: "fa-battery-quarter", faName: "battery-quarter"},
        {name: "battery-0", class: "fa-battery-0", faName: "battery-0"},
        {name: "battery-empty", class: "fa-battery-empty", faName: "battery-empty"},
        {name: "i-cursor", class: "fa-i-cursor", faName: "i-cursor"},
        {name: "object-group", class: "fa-object-group", faName: "object-group"},
        {name: "object-ungroup", class: "fa-object-ungroup", faName: "object-ungroup"},
        {name: "sticky-note", class: "fa-sticky-note", faName: "sticky-note"},
        {name: "sticky-note-o", class: "fa-sticky-note-o", faName: "sticky-note-o"},
        {name: "cc-jcb", class: "fa-cc-jcb", faName: "cc-jcb"},
        {name: "cc-diners-club", class: "fa-cc-diners-club", faName: "cc-diners-club"},
        {name: "clone", class: "fa-clone", faName: "clone"},
        {name: "balance-scale", class: "fa-balance-scale", faName: "balance-scale"},
        {name: "hourglass-o", class: "fa-hourglass-o", faName: "hourglass-o"},
        {name: "hourglass-1", class: "fa-hourglass-1", faName: "hourglass-1"},
        {name: "hourglass-start", class: "fa-hourglass-start", faName: "hourglass-start"},
        {name: "hourglass-2", class: "fa-hourglass-2", faName: "hourglass-2"},
        {name: "hourglass-half", class: "fa-hourglass-half", faName: "hourglass-half"},
        {name: "hourglass-3", class: "fa-hourglass-3", faName: "hourglass-3"},
        {name: "hourglass-end", class: "fa-hourglass-end", faName: "hourglass-end"},
        {name: "hand-grab-o", class: "fa-hand-grab-o", faName: "hand-grab-o"},
        {name: "hand-rock-o", class: "fa-hand-rock-o", faName: "hand-rock-o"},
        {name: "hand-stop-o", class: "fa-hand-stop-o", faName: "hand-stop-o"},
        {name: "hand-paper-o", class: "fa-hand-paper-o", faName: "hand-paper-o"},
        {name: "hand-scissors-o", class: "fa-hand-scissors-o", faName: "hand-scissors-o"},
        {name: "hand-lizard-o", class: "fa-hand-lizard-o", faName: "hand-lizard-o"},
        {name: "hand-spock-o", class: "fa-hand-spock-o", faName: "hand-spock-o"},
        {name: "hand-pointer-o", class: "fa-hand-pointer-o", faName: "hand-pointer-o"},
        {name: "hand-peace-o", class: "fa-hand-peace-o", faName: "hand-peace-o"},
        {name: "registered", class: "fa-registered", faName: "registered"},
        {name: "gg", class: "fa-gg", faName: "gg"},
        {name: "gg-circle", class: "fa-gg-circle", faName: "gg-circle"},
        {name: "odnoklassniki", class: "fa-odnoklassniki", faName: "odnoklassniki"},
        {name: "odnoklassniki-square", class: "fa-odnoklassniki-square", faName: "odnoklassniki-square"},
        {name: "get-pocket", class: "fa-get-pocket", faName: "get-pocket"},
        {name: "wikipedia-w", class: "fa-wikipedia-w", faName: "wikipedia-w"},
        {name: "safari", class: "fa-safari", faName: "safari"},
        {name: "firefox", class: "fa-firefox", faName: "firefox"},
        {name: "opera", class: "fa-opera", faName: "opera"},
        {name: "internet-explorer", class: "fa-internet-explorer", faName: "internet-explorer"},
        {name: "television", class: "fa-television", faName: "television"},
        {name: "contao", class: "fa-contao", faName: "contao"},
        {name: "calendar-plus-o", class: "fa-calendar-plus-o", faName: "calendar-plus-o"},
        {name: "calendar-minus-o", class: "fa-calendar-minus-o", faName: "calendar-minus-o"},
        {name: "calendar-times-o", class: "fa-calendar-times-o", faName: "calendar-times-o"},
        {name: "calendar-check-o", class: "fa-calendar-check-o", faName: "calendar-check-o"},
        {name: "industry", class: "fa-industry", faName: "industry"},
        {name: "map-signs", class: "fa-map-signs", faName: "map-signs"},
        {name: "map-o", class: "fa-map-o", faName: "map-o"},
        {name: "commenting", class: "fa-commenting", faName: "commenting"},
        {name: "commenting-o", class: "fa-commenting-o", faName: "commenting-o"},
        {name: "black-tie", class: "fa-black-tie", faName: "black-tie"},
        {name: "fonticons", class: "fa-fonticons", faName: "fonticons"},
        {name: "reddit-alien", class: "fa-reddit-alien", faName: "reddit-alien"},
        {name: "edge", class: "fa-edge", faName: "edge"},
        {name: "credit-card-alt", class: "fa-credit-card-alt", faName: "credit-card-alt"},
        {name: "codiepie", class: "fa-codiepie", faName: "codiepie"},
        {name: "modx", class: "fa-modx", faName: "modx"},
        {name: "fort-awesome", class: "fa-fort-awesome", faName: "fort-awesome"},
        {name: "usb", class: "fa-usb", faName: "usb"},
        {name: "product-hunt", class: "fa-product-hunt", faName: "product-hunt"},
        {name: "mixcloud", class: "fa-mixcloud", faName: "mixcloud"},
        {name: "pause-circle-o", class: "fa-pause-circle-o", faName: "pause-circle-o"},
        {name: "stop-circle-o", class: "fa-stop-circle-o", faName: "stop-circle-o"},
        {name: "hashtag", class: "fa-hashtag", faName: "hashtag"},
        {name: "bluetooth-b", class: "fa-bluetooth-b", faName: "bluetooth-b"},
        {name: "wpbeginner", class: "fa-wpbeginner", faName: "wpbeginner"},
        {name: "wpforms", class: "fa-wpforms", faName: "wpforms"},
        {name: "envira", class: "fa-envira", faName: "envira"},
        {name: "universal-access", class: "fa-universal-access", faName: "universal-access"},
        {name: "wheelchair-alt", class: "fa-wheelchair-alt", faName: "wheelchair-alt"},
        {name: "question-circle-o", class: "fa-question-circle-o", faName: "question-circle-o"},
        {name: "blind", class: "fa-blind", faName: "blind"},
        {name: "audio-description", class: "fa-audio-description", faName: "audio-description"},
        {name: "volume-control-phone", class: "fa-volume-control-phone", faName: "volume-control-phone"},
        {name: "braille", class: "fa-braille", faName: "braille"},
        {name: "assistive-listening-systems", class: "fa-assistive-listening-systems", faName: "assistive-listening-systems"},
        {name: "asl-interpreting", class: "fa-asl-interpreting", faName: "asl-interpreting"},
        {name: "american-sign-language-interpreting", class: "fa-american-sign-language-interpreting", faName: "american-sign-language-interpreting"},
        {name: "deafness", class: "fa-deafness", faName: "deafness"},
        {name: "hard-of-hearing", class: "fa-hard-of-hearing", faName: "hard-of-hearing"},
        {name: "deaf", class: "fa-deaf", faName: "deaf"},
        {name: "glide", class: "fa-glide", faName: "glide"},
        {name: "glide-g", class: "fa-glide-g", faName: "glide-g"},
        {name: "signing", class: "fa-signing", faName: "signing"},
        {name: "sign-language", class: "fa-sign-language", faName: "sign-language"},
        {name: "low-vision", class: "fa-low-vision", faName: "low-vision"},
        {name: "viadeo", class: "fa-viadeo", faName: "viadeo"},
        {name: "viadeo-square", class: "fa-viadeo-square", faName: "viadeo-square"},
        {name: "snapchat", class: "fa-snapchat", faName: "snapchat"},
        {name: "snapchat-ghost", class: "fa-snapchat-ghost", faName: "snapchat-ghost"},
        {name: "snapchat-square", class: "fa-snapchat-square", faName: "snapchat-square"},
        {name: "pied-piper", class: "fa-pied-piper", faName: "pied-piper"},
        {name: "first-order", class: "fa-first-order", faName: "first-order"},
        {name: "yoast", class: "fa-yoast", faName: "yoast"},
        {name: "themeisle", class: "fa-themeisle", faName: "themeisle"},
        {name: "google-plus-circle", class: "fa-google-plus-circle", faName: "google-plus-circle"},
        {name: "google-plus-official", class: "fa-google-plus-official", faName: "google-plus-official"},
        {name: "fa", class: "fa-fa", faName: "fa"},
        {name: "font-awesome", class: "fa-font-awesome", faName: "font-awesome"},
        {name: "handshake-o", class: "fa-handshake-o", faName: "handshake-o"},
        {name: "envelope-open", class: "fa-envelope-open", faName: "envelope-open"},
        {name: "envelope-open-o", class: "fa-envelope-open-o", faName: "envelope-open-o"},
        {name: "linode", class: "fa-linode", faName: "linode"},
        {name: "address-book", class: "fa-address-book", faName: "address-book"},
        {name: "address-book-o", class: "fa-address-book-o", faName: "address-book-o"},
        {name: "vcard", class: "fa-vcard", faName: "vcard"},
        {name: "address-card", class: "fa-address-card", faName: "address-card"},
        {name: "vcard-o", class: "fa-vcard-o", faName: "vcard-o"},
        {name: "address-card-o", class: "fa-address-card-o", faName: "address-card-o"},
        {name: "user-circle", class: "fa-user-circle", faName: "user-circle"},
        {name: "user-circle-o", class: "fa-user-circle-o", faName: "user-circle-o"},
        {name: "user-o", class: "fa-user-o", faName: "user-o"},
        {name: "id-badge", class: "fa-id-badge", faName: "id-badge"},
        {name: "drivers-license", class: "fa-drivers-license", faName: "drivers-license"},
        {name: "id-card", class: "fa-id-card", faName: "id-card"},
        {name: "drivers-license-o", class: "fa-drivers-license-o", faName: "drivers-license-o"},
        {name: "id-card-o", class: "fa-id-card-o", faName: "id-card-o"},
        {name: "quora", class: "fa-quora", faName: "quora"},
        {name: "free-code-camp", class: "fa-free-code-camp", faName: "free-code-camp"},
        {name: "telegram", class: "fa-telegram", faName: "telegram"},
        {name: "thermometer-4", class: "fa-thermometer-4", faName: "thermometer-4"},
        {name: "thermometer-full", class: "fa-thermometer-full", faName: "thermometer-full"},
        {name: "thermometer-3", class: "fa-thermometer-3", faName: "thermometer-3"},
        {name: "thermometer-three-quarters", class: "fa-thermometer-three-quarters", faName: "thermometer-three-quarters"},
        {name: "thermometer-2", class: "fa-thermometer-2", faName: "thermometer-2"},
        {name: "thermometer-half", class: "fa-thermometer-half", faName: "thermometer-half"},
        {name: "thermometer-1", class: "fa-thermometer-1", faName: "thermometer-1"},
        {name: "thermometer-quarter", class: "fa-thermometer-quarter", faName: "thermometer-quarter"},
        {name: "thermometer-0", class: "fa-thermometer-0", faName: "thermometer-0"},
        {name: "thermometer-empty", class: "fa-thermometer-empty", faName: "thermometer-empty"},
        {name: "shower", class: "fa-shower", faName: "shower"},
        {name: "bathtub", class: "fa-bathtub", faName: "bathtub"},
        {name: "s15", class: "fa-s15", faName: "s15"},
        {name: "bath", class: "fa-bath", faName: "bath"},
        {name: "podcast", class: "fa-podcast", faName: "podcast"},
        {name: "window-maximize", class: "fa-window-maximize", faName: "window-maximize"},
        {name: "window-minimize", class: "fa-window-minimize", faName: "window-minimize"},
        {name: "window-restore", class: "fa-window-restore", faName: "window-restore"},
        {name: "times-rectangle", class: "fa-times-rectangle", faName: "times-rectangle"},
        {name: "window-close", class: "fa-window-close", faName: "window-close"},
        {name: "times-rectangle-o", class: "fa-times-rectangle-o", faName: "times-rectangle-o"},
        {name: "window-close-o", class: "fa-window-close-o", faName: "window-close-o"},
        {name: "bandcamp", class: "fa-bandcamp", faName: "bandcamp"},
        {name: "grav", class: "fa-grav", faName: "grav"},
        {name: "etsy", class: "fa-etsy", faName: "etsy"},
        {name: "imdb", class: "fa-imdb", faName: "imdb"},
        {name: "ravelry", class: "fa-ravelry", faName: "ravelry"},
        {name: "eercast", class: "fa-eercast", faName: "eercast"},
        {name: "microchip", class: "fa-microchip", faName: "microchip"},
        {name: "snowflake-o", class: "fa-snowflake-o", faName: "snowflake-o"},
        {name: "superpowers", class: "fa-superpowers", faName: "superpowers"},
        {name: "wpexplorer", class: "fa-wpexplorer", faName: "wpexplorer"},
        {name: "meetup", class: "fa-meetup", faName: "meetup"},
        {name: "meetup", class: "fa-meetup", faName: "meetup"},
    ]

    const searchQuery = ref('')
    const selectedIcon = ref(null)

    const filteredIcons = computed(() => {
        if (!searchQuery.value) {
            return icons;
        }

        const query = searchQuery.value.toLowerCase();

        return icons.filter(icon =>
            icon.name.toLowerCase().includes(query) ||
            icon.class.toLowerCase().includes(query)
        );
    })


    const selectIcon = (icon) => {
        selectedIcon.value = icon;
        emit('select-icon', selectedIcon.value);
    }

    const selectWeight = (iconWeight) => {

        emit('select-weight', [iconWeight, selectedIcon.value.class].join(' '));
        emit('close');

        selectedIcon.value = null
    }

</script>
<template>
    <div>
      <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 transition-opacity" @click="emit('close')">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div class="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-wl shadow-xl w-full">
          <div class="bg-white px-4">
            <div
                v-if="selectedIcon === null"
                class="sm:flex sm:items-start"
            >
              <div class="w-full text-center">
                <div class="mt-4">
                  <input-text
                    type="text"
                    autofocus
                    v-model:content="searchQuery"
                    :placeholder="_mft('shared:search')"
                  />

                  <div class="grid grid-cols-6 gap-4 overflow-y-auto max-h-64">
                    <button
                      v-for="icon in filteredIcons"
                      :key="icon.class"
                      @click="selectIcon(icon)"
                      class="flex flex-col items-center justify-center p-2 rounded hover:bg-gray-100"
                    >
                      <i :class="icon.class" class="mb-1 text-xl fa-solid"></i>
                      <span class="w-full text-xs text-center truncate">{{ icon.name }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
                v-if="selectedIcon !== null"
            >
                <ul class="grid grid-cols-4 pt-6 pb-4">
                    <li class="text-center">
                        <button @click="selectWeight('fa-solid')">
                            <i class="text-xl fa-solid" :class="selectedIcon.class"></i>
                        </button>
                    </li>
                    <li class="text-center">
                        <button @click="selectWeight('fa-regular')">
                            <i class="text-xl fa-regular" :class="selectedIcon.class"></i>
                        </button>
                    </li>
                    <li class="text-center">
                        <button @click="selectWeight('fa-light')">
                            <i class="text-xl fa-light" :class="selectedIcon.class"></i>
                        </button>
                    </li>
                    <li class="text-center">
                        <button @click="selectWeight('fa-thin')">
                            <i class="text-xl fa-thin" :class="selectedIcon.class"></i>
                        </button>
                    </li>
                </ul>
            </div>
          </div>

          <div class="px-4 pb-3 bg-white flex justify-end">
            <button-base
              size="sm"
              @click="emit('close')"
            >
              {{ _mft('shared:action.cancel') }}
            </button-base>
          </div>
        </div>
      </div>
    </div>
  </template>
